import React, { useEffect, useState, useContext } from 'react';

import { VENUES_CONSTANTS } from 'AppConstants';
import { StickyBottomBtn } from './Styles';
import BannerCarousel from '../mice/components/BannerCarousel/BannerCarousel';
import HowItWork from '../mice/components/HowItWork/HowItWork';
import Button from 'common/Button/Button';
import WhyChooseMmt from '../mice/components/WhyChooseMmt/WhyChooseMmt';
import { logPageLoadEvents } from 'omnitures';
import DropQuery from './components/DropQuery/DropQuery';

import DisplayContext from 'UtilityComponents/displayContext';
import MetaTags from 'common/metaTags';
import { QUERY_BTN_TXT, PAGE_TITLE, chooseMmtBusinessData, bannerCarouselData } from './config';
import { ASSET_PATH } from 'assetsPath';

const Mice = (props) => {
	const { queryForm, toggleForm } = props;
	const [stickyBottom, setStickyBottom] = useState(false);

	const displayName = useContext(DisplayContext).isMobile;
	const isMobileView = displayName == 'mobile';

	useEffect(() => {
		logPageLoadEvents(VENUES_CONSTANTS.PAGE_NAME);
		const eventHandler = () => setStickyBottom(window.pageYOffset > 500);
		eventHandler();
		if (typeof window !== 'undefined') {
			window.addEventListener('scroll', eventHandler);
		}
		return () => {
			if (typeof window !== 'undefined') {
				window.removeEventListener('scroll', eventHandler);
			}
		};
	}, []);

	return (
		<>
			<MetaTags titleTxt={PAGE_TITLE} />
			<div>
				<BannerCarousel
					toggleForm={toggleForm}
					config={{ bannerCarouselData,
						QUERY_BTN_TXT,
						imgUrl: ASSET_PATH.IMAGES + '/mice/venues_bg.png',
						bg: 'linear-gradient(117.53deg ,rgba(255,255,255,0.9) 1.15%,rgba(216,205,190,0.6) 100%)' }}
				/>
				<HowItWork colorTheme='light' />
				<WhyChooseMmt colorTheme='dark' chooseMmtBusinessData={chooseMmtBusinessData} />
			</div>
			{isMobileView && stickyBottom && (
			<StickyBottomBtn>
				<Button
					btnTxt={QUERY_BTN_TXT}
					btnType='Flat'
					btnName='Primary'
					btnShadow
					btnWidth='100%'
					height='44px'
					handleClick={toggleForm}
				/>
			</StickyBottomBtn>
			)}
			{queryForm && <DropQuery closeForm={toggleForm} isMobile={isMobileView} />}
		</>
	);
};

export default Mice;
